var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePagesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.85,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 .696A.696.696 0 0 0 15.304 0H2.783a.696.696 0 0 0-.696.696v12.521c0 .385.311.696.696.696h12.521a.696.696 0 0 0 .696-.696V.696z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.087 2.783H.696A.696.696 0 0 0 0 3.478v11.826c0 .385.311.696.696.696h11.826a.696.696 0 0 0 .695-.696v-1.391"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePagesIcon);
export default __webpack_public_path__ + "static/media/white-pages-icon.46fcaab1f893937387a132497f4f6491.svg";
export { ForwardRef as ReactComponent };